import { StoreState } from '../store'

export const selectOrganizationType = (state: StoreState) =>
  state.organization.type

export const selectOrganizationId = (state: StoreState) => state.organization.id
